import { MySurveysPageIndexDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useActivities } from 'modules/core/lib/activities/provider'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { MySurveysDataCollection } from 'modules/trainings/components/MyTrainings/MySurveys/MySurveysDataCollection'

const Surveys = () => {
  const { loading, error } = useQuery(MySurveysPageIndexDocument)
  const { navigation } = useNavigation()
  const { openActivity } = useActivities()

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <MySurveysDataCollection
        onFormSelect={(form) => {
          if (form.hasPreviousAnswers) {
            openActivity('forms.formResponses', {
              formId: form.formId,
              membershipId: form.membershipId,
              resourceType: 'Trainings::Training',
              materializedFormResourceType: 'Trainings::TrainingClass',
            })
            return
          }

          openActivity('forms.answerForm', {
            formId: form.formId,
            membershipId: form.membershipId,
            resourceType: 'Trainings::Training',
            closePath: navigation.myTrainings.surveys.fullPath(),
            submitSuccessPath:
              form.formType === 'knowledge'
                ? navigation.myTrainings.surveys.score.fullPath({
                    membership_id: form.membershipId,
                    materialized_form_id: form.materializedFormId,
                  })
                : navigation.myTrainings.surveys.fullPath(),
          })
        }}
      />
    </ResponsivePage.Body>
  )
}
export default Surveys
